<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="dialog = false">
    <v-card flat>
      <v-card-title>
        Live Survey Link
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle>
        Share this link and start collecting responses
      </v-card-subtitle>
      <v-card-text>
        <survey-live-link :instance="instance"></survey-live-link>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import SurveyLiveLink from "@/components/surveys/SurveyLiveLink";
export default {
  name: "SurveyLiveLinkDialog",
  components: {
    SurveyLiveLink
  },
  data: () => ({
    dialog: false,
    surveyId: null,
    surveyInstanceId: null
  }),
  computed: {
    ...mapGetters({
      instance: "survey/instance"
    })
  },
  methods: {
    showDialog(surveyId, surveyInstanceId) {
      this.dialog = true;
      this.surveyId = surveyId;
      this.surveyInstanceId = surveyInstanceId;

      this.$store
        .dispatch("survey/getSurveyInstance", {
          surveyId,
          id: surveyInstanceId
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading your survey's recipients."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
